import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export const fm = (
  id: string,
  values?: { [key: string]: string | number | ((chunks: React.ReactNode[]) => React.JSX.Element) | React.JSX.Element },
  key?: string,
): React.JSX.Element => <FormattedMessage id={id} values={values} key={key} />;
